export enum PaginationButtonDirections {
  left = 'left',
  right = 'right',
}

export type PaginationButtonDirection =
  | PaginationButtonDirections.left
  | PaginationButtonDirections.right;
